export const workContent = [
    {
        name: "MangaDex v5",
        id: "mangadex",
        filter: "personal",
        image: require("./mangadex/cover.png").default,
        desc: {
            type: "Web App UI/UX Design",
            client: "Personal Project, MangaDex (2020)",
            tools: "Figma",
            credits: "Me, Arvid, sheruchan",
            content: "MangaDex is a fan-driven, fan-made online manga reader made for scanlators and readers to give them a safe place to discover and experience their favorite manga with high-quality translations and ways to support their favorite authors.\n\nCharmed by their work, I decided to volunteer as their UI/UX designer for their new planned site rewrite, called v5.\n\nAs luck may have it, a few weeks after I joined their design team, the site was attacked by an unknown actor. During this period, the MangaDex team decided to refocus and expedite their planned rewrite of the site.\n\nThe screenshots that I am able to share now are limited and subject to change as the website development is currently ongoing.",
            case:{
                exist: false,
                url: "",
            }
        },
        misc:{
            live: "https://mangadex.org/",
            figma:{
                value: false,
                link: "",   
            },
            image:{
                cover: require("./mangadex/header.png").default,
                content: require("./mangadex/content.png").default,
            }
        } 
    },{
        name: "URANIME",
        id: "uranime",
        filter: "personal",
        image: require("./uranime/cover.png").default,
        desc: {
            type: "App UI/UX Design",
            client: "Personal Project (2020)",
            tools: "Figma",
            credits: null,
            content: "URANIME is a personal project and my personal take on what a native anime streaming Android app would look like.\n\nIn practice, the app will outsources shows detail - both series and movies, from MyAnimeList, an anime and manga database website that will enable functions such as bookmarking, following, discovery and community recommendations.\nIt will also allow users to choose their desired streaming server for each anime from the already existing fan supported streaming servicecs.\n\nThe design is currently unfinished and the live prototype you see below is a work-in-progress.",
            case:{
                exist: false,
                url: "",
            }
        },
        misc:{
            live: false,
            figma:{
                value: true,
                link: "https%3A%2F%2Fwww.figma.com%2Fproto%2F2DtKBRlrGBS6sH0d300YXg%2FURANIME%3Fnode-id%3D1%253A2%26scaling%3Dscale-down",   
            },
            image:{
                cover: require("./uranime/header.png").default,
                content: require("./uranime/content.png").default,
            }
        } 
    },
    {
        name: "泡盛まさひろ台灣",
        id: "awamori-masahiro",
        filter: "professional",
        image: require("./masahirotw/cover.png").default,
        desc: {
            type: "Website Design",
            client: "まさひろ酒造株式会社 (2020)",
            tools: "Adobe Photoshop, CSS, WordPress",
            credits: null,
            content: "Masahiro is a sake brewery company located in Okinawa, Japan that is famous for its awamori.\n\nAt the time, the company was trying to expand its business to Taiwan and was looking to build a simple responsive landing page that can convey its brand and present its products that appeal to the younger Taiwanese crowd without being overwhelming.",
            case:{
                exist: true,
                url: require("./masahirotw/case.md").default,
            }
        },
        misc:{
            live: "../work/awamori-masahiro/preview/",
            figma:{
                value: false,   
            },
            image:{
                cover: require("./masahirotw/header.png").default,
                content: require("./masahirotw/content.png").default,
            }
        } 
    },
    {
        name: "Express Bahari App Design",
        id: "express-bahari-app",
        filter: "professional",
        image: require("./expressbahari-app/cover.png").default,
        desc: {
            type: "App UI/UX Design",
            client: "PT. Pelayaran Sakti Inti Makmur (2020)",
            tools: "Adobe Xd, Adobe Photoshop",
            credits: null,
            content: "Having done the website redesign of Express Bahari previously, the company later asked me to design the UI and UX of their upcoming smartphone app that has features, such as allowing users to book and see their trip detail, redeem promo codes, push notifications, and rewards system.\n\nClick the 'Live Prototype' button below to see the finished prototype.",
            case:{
                exist: false,
                url: "",
            }
        },
        misc:{
            live: false,
            figma:{
                value: true,
                link: "https%3A%2F%2Fwww.figma.com%2Fproto%2Fr0eXArW9CuWvagdOSXOhCb%2FExpress-Bahari%3Fnode-id%3D1%253A2%26scaling%3Dscale-down",   
            },
            image:{
                cover: require("./expressbahari-app/header.png").default,
                content: require("./expressbahari-app/content.png").default,
            }
        } 
    },
    {
        name: "Express Bahari Website Redesign",
        id: "express-bahari-web",
        filter: "professional",
        image: require("./expressbahari-web/cover.png").default,
        desc: {
            type: "Website Design",
            client: "PT. Pelayaran Sakti Inti Makmur (2019)",
            tools: "Adobe Photoshop, HTML, CSS, JavaScript",
            credits: null,
            content: "Express Bahari, one of the biggest ferry service in Indonesia approached me to do a re-design their website.\n\nWith the recent meteoric rise of smartphone users in Indonesia, they decided to upgrade its service by building a responsive website that has location-based ferry timetables, promo selections, and most importantly it has to be user friendly no matter on mobile, tablet, or PC.\n\nFollowing the redesign, the company liked my design direction and asked me to do UI/UX design for their upcoming smartphone app that has features, such as allowing users to book and see their trip detail, redeem promo codes, push notifications, and rewards system.",
            case:{
                exist: true,
                url: require("./expressbahari-web/case.md").default,
            }
        },
        misc:{
            live: "https://oiwyn.github.io/express-bahari/",
            figma:{
                value: false, 
            },
            image:{
                cover: require("./expressbahari-web/header.png").default,
                content: require("./expressbahari-web/content.png").default,
            }
        } 
    },
    {
        name: "Pronovias台灣",
        id: "pronoviastw",
        filter: "professional",
        image: require("./pronoviastw/cover.png").default,
        desc: {
            type: "Website Design",
            client: "ClubMax Studio (2019)",
            tools: "Wix",
            credits: null,
            content: "My position at ClubMax, a wedding oriented company located at Taipei and one of the Pronovias dresses distributor in Taiwan, required me to design a website that allows our clients to browse dresses and book appointment online.\n\nSince our time was limited, the management and the sales teams decided to build the website on Wix as they found Wix had the easiest system for them to manage.\nAs Wix's features were limited, my work was mostly on designing the website layout, daily troubleshooting, and weekly dresses database management.",
            case:{
                exist: false,
                url: "",
            }
        },
        misc:{
            live: false,
            figma:{
                value: false,   
            },
            image:{
                cover: require("./pronoviastw/header.png").default,
                content: require("./pronoviastw/content.png").default,
            }
        } 
    },
    {
        name: "EventME",
        id: "eventme",
        filter: "personal",
        image: require("./eventme/cover.png").default,
        desc: {
            type: "App UI/UX Design",
            client: "James Cook University (2017)",
            tools: "Adobe Xd, Adobe Photoshop",
            credits: null,
            content: "My capstone project for my bachelor's degree was to create an app that combines good UI with UX that eases a student campus' life both inside and outside campus. \n\nThe app was designed with aim to provide students with features that can enrich their campus' life, such as, class and its assignment details and reminders, on-going and future campus' events reminders, smart band sync function, maps and real-time bus tracking function.",
            case:{
                exist: false,
                url: "",
            }
        },
        misc:{
            live: false,
            figma:{
                value: false,   
            },
            image:{
                cover: require("./eventme/header.png").default,
                content: require("./eventme/content.png").default,
            }
        } 
    },
]